<template>
  <div>
    <VTable class="managers-manager" :items="computedItems" :fields="fields" :checked-rows="checkedItems"
    :handleChangeState="handleChangeState"
      :loading="loading" :on-toggle-row="onToggleRow" :on-input-search="onInputSearch" :on-edit-item="onEditItem"
      :on-delete-item="onDeleteItem" :on-click-to-add="onClickToAdd" searchPlaceholder="Search for VDP article title...." hover
      striped border small fixed dark>
      <template #footer>
        <VPagination :items-count="itemsCount" class="user-manager-card__footer-pagination" />
      </template>
    </VTable>
  </div>
</template>
<script>
import {
  createVdpArticleMixin,
  vdpArticleStore,
} from "@/mixins/vdpArticleMixin";
import {
  createMarketplaceMixin,
  marketplaceStore,
} from "@/mixins/marketplaceMixin";
import { debounce } from "@/utils/debounce";
import ModalType from '../utils/dictionaries/modalType';

export default {
  name: 'VdpArticles',
  mixins: [createVdpArticleMixin(), createMarketplaceMixin()],
  data() {
    return {
      title: '',
      content: '',
      isDisabled: false,
      loading: false,

      data: [],
      count: 0,
      checkedItems: [],
    };
  },
  computed: {
    getStates(){
      return this[marketplaceStore.getterTypes.GETTER_STATES];
    },
    fields() {
      return [
        { key: "rowId", label: "" },
        { key: "truncated_title", label: "Title", _style: "max-width: 100px" },
        {
          key: "truncated_content",
          label: "Content",
          // _style: "min-width: 125px",
          // _classes: "blog-content"
        },
        {
          key: "state",
          label: "Assigned State",
          _style: "min-width: 100px",
          _classes: "states"
        },
        { key: "action", _style: "max-width: 20px;min-width:20px" }
      ]
    },
    items() {
      return this[vdpArticleStore.getterTypes.GETTER_VDP_ARTICLES];
    },
    itemsCount() {
      return this[vdpArticleStore.getterTypes.GETTER_VDP_ARTICLES_COUNT];
    },
    computedItems() {
      return this.items && this.items.map(item => {
        return {
          ...item,
          truncated_title: item.title.length > 100 ? item.title.substring(0, 100) + '...' : item.title,
          truncated_content: item.content.length > 100 ? item.content.substring(0, 100) + '...' : item.content,
          states: this.getStates
        }
      })
    }
  },

  watch: {
    $route() {
      this.loadData()
    }
  },

  async created() {
    await this.loadData()

    this.searchFn = debounce.call(
      this,
      async term => {
        const query = {
          ...this.$route.query,
          search: term
        }

        if (!query.search && query.offset) {
          query.offset = 0;
        }

        this.$router
          .push({
            query
          })
          .catch(() => { })
      },
      200
    )
  },
  methods: {
    handleChangeState(value, id){
      this.updateArticleState(value, id)
    },
    onToggleRow(item) {
      // this.checkedItems = [item]
    },
    onInputSearch(t) {
      this.searchFn(t)
      console.log('onInputSearch', t)
    },
    onEditItem(item) {
      this.$modals.open(ModalType.VdpModal, item)
    },
    async onDeleteItem(item) {
      const deleteAction = async () => {
        try {
          const blogId = item.id
          this.$modals.close(ModalType.ConfirmationModal)
          await this[vdpArticleStore.actionTypes.ACTION_DELETE_VDP_ARTICLE]({ blogId })
        } catch (error) {
          console.log(error)
          console.log(error.response)
        }
      }
      this.$modals.open(ModalType.ConfirmationModal, {
        title: 'Deletion',
        body: `Are you sure you want to delete <strong>${item.title}</strong> VDP article?`,
        buttonText: 'Delete',
        onClickButton: deleteAction
      })
    },
    onClickToAdd() {
      this.$modals.open(ModalType.VdpModal, {})
    },
    async loadData() {
      try{
        this.loading = true;
      await this[vdpArticleStore.actionTypes.ACTION_LOAD_VDP_ARTICLES]({
        skip: this.$route.query.skip || 0,
        take: this.$route.query.take || 10,
        search: this.$route.query.search || ''
      })
      await this[marketplaceStore.actionTypes.GET_STATES]({
      });
      this.loading = false
      }catch(err){
        console.log("Error in loading VDP article", err)
        this.loading = false

      }
     
    },
    async updateArticleState(value, id) {
      try{
        this.loading = true;
      await this[vdpArticleStore.actionTypes.ACTION_UPDATE_VDP_ARTICLE_STATE]({
        id: id,
        value: value,
      })
      this.loadData()
      this.loading = false
      }catch(err){
        console.log("Error in loading VDP article", err)
        this.loading = false

      }
     
    },
  }
}
</script>
